import type { TokenResult } from '@/utils/0x/token-registry.types';

import { LiquidityScore } from './LiquidityScore';
import { SecurityScore } from './SecurityScore';

export const Scores = ({ token }: { token: TokenResult | undefined }) => {
  return (
    <div className="flex mt-1 gap-2 px-4">
      <div className="flex-1">
        <LiquidityScore token={token} />
      </div>
      <div className="flex-1">
        <SecurityScore token={token} />
      </div>
    </div>
  );
};
